<template>
  <div class="login">
    <form
      v-if="!showSpinner"
      @submit.prevent="handleSubmit"
    >
      <input
        v-model="email"
        type="text"
        required
        placeholder="username"
      >
      <input
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        required
        placeholder="password"
      >
      <label>
        <input
          v-model="showPassword"
          type="checkbox"
        >
        Show password
      </label>
      <br>
      <button>Log in</button>
    </form>
    <Spinner v-else />
    <div v-if="error" class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import useLogin from '@/composables/useLogin'
import Spinner from '@/components/Spinner.vue'

export default {
  components: { Spinner },
  setup (props, context) {
    // refs
    const email = ref('')
    const password = ref('')
    const showPassword = ref(false)
    const showSpinner = ref(false)

    const { error, login } = useLogin()

    const handleSubmit = async () => {
      showSpinner.value = true
      const userName = email.value.indexOf('@') !== -1
        ? email.value : email.value + '@inspireschool.com'
      await login(userName, password.value)
      if (!error.value) {
        context.emit('login')
      }
    }

    return { email, password, handleSubmit, error, showPassword, showSpinner }
  }
}
</script>

<style>
.login form {
  background: transparent;
}
.login .error {
  font-size: 1.1em;
}
.login input {
  border: 1px solid #ddd;
  margin-top: 0.5em;
}
.login input[type="checkbox"] {
  display: inline-block;
  position: relative;
  top: 2px;
  margin: 0 10px 0 0;
  width: 16px;
}

</style>
